<script>
export default {
  name: 'MemberSubmenu',
  data () {
    return {
      selectedTab: 0
    }
  },
  watch: {
    selectedTab () {
      this.redirect(this.selectedTab)
    },
    '$route.name': {
      immediate: true,
      handler () {
        if (this.$route.name.includes('invite')) {
          this.selectedTab = 1
        } else if (this.$route.name.includes('list')) {
          this.selectedTab = 0
        } else {
          this.redirect(0)
        }
      }
    }
  },
  methods: {
    redirect (index) {
      switch (index) {
        case 0:
          this.$router.push({ name: this.selectedWorkspace.type + '.home.user.members.list' })
          break
        case 1:
          this.$router.push({ name: this.selectedWorkspace.type + '.home.user.members.invites' })
          break
      }
    }
  }
}
</script>
<template>
  <div class="workspace-management--members-container">
    <v-tabs v-if="userCanManage(selectedWorkspace.id)" :show-arrows="isMobile" v-model="selectedTab" slider-size="4">
      <v-tab class="btn">{{ $t('members.menu.members.list') }}</v-tab>
      <v-tab class="btn">{{ $t('members.menu.invites.list') }}</v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>
<style lang="scss">
.workspace-management--members-container {
  padding: 20px 0 0;
  .theme--light.v-tabs > .v-tabs-bar {
    color: $primary-medium !important;
    caret-color: $primary-medium !important;
    background-color: transparent;
    margin-bottom: 20px;
    z-index: 10;
  }
  .workspace-management--members__actions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .order-by--select {
      max-width: 215px;
    }
  }
  .workspace-management--members__list {
    .member-table--line {
      .workspace-members--user-info {
        display: flex;
        align-items: center;
        .workspace-members--user-name {
          margin-left: 8px;
          color: $neutral-darkest;
          font-family: $lato;
          font-size: 14px;
        }
        .workspace-members--user-picture {
          display: inline-block;
          max-height: 30px;
          max-width: 30px;
          border-radius: 100px;
        }
      }
    }
    .v-data-footer {
      padding: 0 20px;
    }
  }
  @media only screen and (max-width: 768px) {
    .workspace-management--members__actions {
      align-items: flex-start;
      margin-left: 20px;
    }
  }
}
</style>
